<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Creazione nuovo ramo
  </span>
  <ng-template #editHeader>
    Modifica ramo {{data.nome}}
  </ng-template>
</h4>

<form [formGroup]="form" class="mt-4" (keydown.enter)="edit()">
  <div>
    <mat-form-field>
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome">
      <mat-icon matSuffix>nome</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Gruppo Rami</mat-label>
      <gruppo-rami-picker matInput formControlName="gruppo_rami"></gruppo-rami-picker>
    </mat-form-field>
  </div>
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>